import React from 'react';
import { IconUsersGroup } from '@tabler/icons-react';
import { BoardClickUpFilterChipDropdown } from './BoardClickUpFilterChipDropdown';

/**
 * Chip "Técnicos" estilo ClickUp — submenu Board (teste A/B ao lado do chip legado).
 */
export function BoardToolbarTecnicosClickUpChip(props) {
  return (
    <BoardClickUpFilterChipDropdown
      {...props}
      label="Técnicos"
      icon={IconUsersGroup}
      pickerMode="simple"
      pickerWidth={238}
      pickerMaxHeight={320}
      searchPlaceholder="Buscar"
      countLabel="técnicos"
      listAriaLabel="Técnicos"
      popoverClassName="board-search-filters-popover--tecnico"
      showSimpleBulkMenu
      emptyMessage="Nenhum técnico encontrado"
    />
  );
}
